import { Button } from "@designs-by-maryam/ui/components/button";
import { Globe } from "lucide-react";
import { useLanguage } from "@/lib/language";

export function LanguageToggle() {
	const { language, toggleLanguage } = useLanguage();
	const isArabic = language === "ar";

	return (
		<Button
			aria-label={`Switch to ${isArabic ? "English" : "Arabic"}`}
			aria-pressed={isArabic}
			className="h-9 gap-1.5 rounded-full px-3"
			onClick={toggleLanguage}
			role="switch"
			size="sm"
			variant="ghost"
		>
			<Globe className="h-4 w-4" />
			<span className="font-medium text-xs uppercase">
				{isArabic ? "EN" : "AR"}
			</span>
		</Button>
	);
}
